export default {
  empty: 'No results',
  item: function item(data) {
    return JSON.stringify(data, null, 2);
  }
};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/newton/wp-content/themes/newton/node_modules/instantsearch.js/es/widgets/infinite-hits/defaultTemplates.js
// module id = 658
// module chunks = 0